import script from "./NewSalesListsDetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewSalesListsDetailsView.vue?vue&type=script&setup=true&lang=js"

import "./NewSalesListsDetailsView.vue?vue&type=style&index=0&id=5ce4bea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ce4bea2"]])

export default __exports__